import React from 'react';
import ReactDOM from 'react-dom';
import {browserHistory, Router} from 'react-router';
import {Provider} from 'react-redux';
import rootStore from './reducers';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import routes from './routes.js';
import maintenanceRoutes from './maintenance-routes.js';
import httpServiceConfiguration from 'httpServiceConfiguration';
import httpService from './services/httpService.js';
import _ from 'lodash';

httpService.getInstance(httpServiceConfiguration);//will keep config in singleton
//this way, instead of using resolve.alias of webpack (and having the require of module messed up by webpack when they'll be executed server-side)
//I use dependency injection, in the one place that won't be executed in node : the client side bootstrap

const history = createBrowserHistory();

//Disable console.log on production
if (__ENV__ === 'production') {
    console.log = function () {
    };
}

// replace with valid url if exist any tag
function sanitizeReqLink() {
    let url = decodeURIComponent(window.location.pathname);
    const unvalidMatch = /[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)]/;

    const isExist = url.match(unvalidMatch);
    if (!_.isEmpty(isExist)) {
        url = url.slice(0, isExist.index);
        browserHistory.push(url);
    }
}

function hashLinkScroll() {
    let SET_INTERVAL;
    let CURRENT_TRY = 1;
    const MAX_TRIES = 100;

    (function checkToScroll() {
        sanitizeReqLink();
        const hash = window.location.hash.replace('#', '').trim();
        if (!hash) {
            return;
        }

        if (CURRENT_TRY > MAX_TRIES) {
            console.warn(`hashLinkScroll() didn't manage to find the specified DOM element «${ hash }» after ${ MAX_TRIES } tries`);
            clearInterval(SET_INTERVAL);
            return;
        }
        const section = document.getElementById(hash);
        const header = document.getElementsByTagName('header');
        if (section && header && header[0]) {
            clearInterval(SET_INTERVAL);
            window.scrollTo({
                top: section.offsetTop - header[0].offsetHeight,
                behavior: 'smooth'
            });
        } else {
            clearInterval(SET_INTERVAL);
            SET_INTERVAL = setInterval(() => {
                checkToScroll();
                CURRENT_TRY += 1;
            }, 250);
        }
    })(CURRENT_TRY);
}
ReactDOM.hydrate(
        <Provider store={rootStore}>
            <Router history={browserHistory} onUpdate={hashLinkScroll}>{global.__MAINTENANCE_MODE__ === 'true' ? maintenanceRoutes : routes}</Router>
        </Provider>
        , document.getElementById('app-container'));